import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

import { adminElevatorsRoutes } from './elevators/adminElevatorsRoutes';
import { agencyElevatorsRoutes } from './elevators/agencyElevatorsRoutes';
import { clientElevatorsRoutes } from './elevators/clientElevatorsRoutes';

const PREFIX = '/elevators/';

const SwitchPage = lazy(
  () => import('../../../main/elevators/common/switch-page/SwitchPage')
);

export const elevatorsRoutes: Array<RouteConfig> = [
  {
    path: PREFIX + '',
    exact: true,
    component: () => <SwitchPage />,
  },
  ...clientElevatorsRoutes,
  ...agencyElevatorsRoutes,
  ...adminElevatorsRoutes,
];
